import React, { Component, useContext } from 'react';
import { Avatar, Spin, PageHeader, Tooltip, Layout, message, Row, Col, Card, Typography, Tabs, Menu, Space, Button, Result, Popconfirm, Tag, Empty, Badge } from 'antd'
import axios from 'axios';

import { FaRegHandshake } from 'react-icons/fa'
import { useParams, useNavigate, useLocation, matchRoutes } from "react-router-dom";


//Componentes
import Logged from '../../../../Hooks/Logged';
import CustomAvatar from '../../../Widgets/Avatar/Avatar';
import usePermissions from '../../../../Hooks/usePermissions';
import { IconArrowBack } from '../../../Widgets/Iconos';

//Modales






//modal


const { Content } = Layout;
const { Text, Title, Paragraph } = Typography;
const { TabPane } = Tabs;


const moment = require('moment');
moment.locale('es');

/**
 * @export
 * @class DetalleClientes
 * @extends {Component}
 * @description Vista de Detalle Clientes
 */
class InformacionGeneral extends Component {

    constructor(props) {
        super(props)
        this.state = {
            empleado: {},

        }
    }



    componentDidMount() {
        this.get()
    }



    /**
     * @memberof DetallesClientes
     * @method get
     * @description Obtiene los detalles y propiedades del cliente
     *
     */
    get = () => {
        this.setState({ loading: true })
        axios.get('/empleados/' + this.props.id)
            .then(({ data }) => {
                this.setState({ empleado: data })
            }).catch(error => {
                message.error('Error al obtener el empleado')
            }).finally(() => this.setState({ loading: false }))
    }


    render() {
        const { empleado, cliente } = this.state


        return (
            <>
                <Spin spinning={false}>


                    <Col span={24}>
                        <Card bordered>
                            <Row align="middle" className='mb-1' gutter={[12, 12]}>
                                <Col>
                                    <Title level={4} >Información General</Title>
                                </Col>
                            </Row>



                            <Col xs={24} lg={24}>
                                <Row>
                                    {
                                        empleado?.fecha_nacimiento ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Fecha de Nacimiento</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{moment(empleado?.fecha_nacimiento).format('YYYY-MM-DD')}</Paragraph>
                                            </Col> : null
                                    }

                                    {
                                        empleado?.genero ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Género</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.genero}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.curp ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>CURP</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.curp}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.rfc ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>RFC</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.rfc}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.pais_nacimiento ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>País de Nacimiento</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.pais_nacimiento}</Paragraph>
                                            </Col> : null
                                    }
                                    {
                                        empleado?.estado_nacimiento ?
                                            <Col xs={24} lg={12} xl={6}>
                                                <Paragraph>Estado / Provincia de Nacimiento</Paragraph>
                                                <Paragraph strong style={{ fontSize: 16 }}>{empleado?.estado_nacimiento}</Paragraph>
                                            </Col> : null
                                    }
                                
                                </Row>
                            </Col>



                        </Card>
                    </Col>

                </Spin>
            </>
        )
    }
}

export default function (props) {


    const user = useContext(Logged);

    const permisos = usePermissions(user?.rol_id?.permisos, {
        crearPropiedades: ["clientes", "propiedades", "create"],

        verTransaccionesPropiedad: ["clientes", "propiedades", "transacciones", "access"],
        crearTransaccionesPropiedad: ["clientes", "propiedades", "transacciones", "create"],

        verTransaccionesProgramadasPropiedad: ["clientes", "propiedades", "transacciones-programadas", "access"],
        crearTransaccionesProgramadasPropiedad: ["clientes", "propiedades", "transacciones-programadas", "create"],
    });

    return <InformacionGeneral

        {...permisos}
        {...props}
    />
}